import { useQuery } from '@tanstack/react-query';

import { getOfferingTransactionDocuments } from '@arrived/api_v2';
import { OfferingTransactionDocument, OfferingTransactionId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { tradeDocumentsQueryKeyFn } from './trades.keys';

export function useGetTradeDocumentsQuery(
  tradeId: OfferingTransactionId,
  options?: UseQueryOptions<OfferingTransactionDocument>
) {
  return useQuery(tradeDocumentsQueryKeyFn(tradeId), async () => getOfferingTransactionDocuments(tradeId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
